import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'keys',
  standalone: false,
})
export class KeysPipe implements PipeTransform {
  transform(value: object): string[] {
    return Object.keys(value)
  }
}

@Pipe({
  name: 'enumValues',
  standalone: false,
})
export class EnumValuesPipe implements PipeTransform {
  transform<T>(value: {}): any
  transform<T>(value: { [s: string]: T } | ArrayLike<T>): T[] {
    const values = Object.values(value)
    const halfLength = values.length / 2

    return values.slice(halfLength)
  }
}
